import React, { PureComponent } from "react";

import NumericLabel from "react-pretty-numbers";

import numeral from "numeral";
import Select from "react-select";

import styles from "./style.module.css";

import { Button, ButtonGroup } from "aible";

import { Popover, OverlayTrigger } from "react-bootstrap";

import { colors as nextColors } from "containers/Next/NextReducer";

import VotingIcon from "images/Next-Icons/model-voting.svg";

export default class Heatmap extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {};
  }

  renderIcon() {
    const { chart } = this.props;

    const background = chart?.color ?? "grey";

    const rHexSize = 30;

    return (
      <div
        className={styles.hexagon + " " + styles.hIcon}
        style={{
          height: rHexSize - 3 + "px",
          width: (rHexSize - 3) * (110 / 190) + "px",
          marginLeft: "10px",
          background: background
        }}
      >
        <div className={styles.face1 + " " + styles.hIcon} style={{ background: background }}></div>
        <div className={styles.face2 + " " + styles.hIcon} style={{ background: background }}></div>
        <img src={VotingIcon} style={{ transform: "scale(0.5)" }} />
      </div>
    );
  }

  render() {
    const {
      node,
      chart,
      style,
      isSmall,
      isListChart,
      hideGrid,
      isReport,
      replayActions,
      project,
      runId,
      projectId,
      updateDrilldownValue,
      isHeatmapGlobalScale,
      updateIsHeatmapGlobalScale
    } = this.props;

    const column = chart?.chart?.xAxis?.label;

    let rChart = {};
    let rChartScaled = {};
    let rModels = {};
    let rValues = {};

    let maxY = -9999;

    chart?.chart?.data.forEach((row) => {
      if (rModels[row.y_name] === undefined) {
        rModels[row.y_name] = true;
      }
      if (rValues[row.x_name] === undefined) {
        rValues[row.x_name] = true;
      }

      if (rChart[row.x_name] === undefined) {
        rChart[row.x_name] = {};
      }

      if (rChartScaled[row.x_name] === undefined) {
        rChartScaled[row.x_name] = {};
      }

      rChart[row.x_name][row.y_name] = row.y;
      rChartScaled[row.x_name][row.y_name] = row.scaled_y;

      if (maxY < Math.abs(row.y)) {
        maxY = Math.abs(row.y);
      }
    });

    const values = Object.keys(rValues).map((vKey) => vKey);
    const models = Object.keys(rModels)
      .map((mKey) => mKey)
      .reverse();

    const chartId =
      (isReport ? "nextChartReport_" : "nextChart_") + (chart?.chart?.narrative?.title || chart?.narrative?.title);

    const currentSegment =
      runId !== undefined ? project.segments.filter((segment) => segment?.job?.job_id === runId)?.[0] : undefined;

    const renderPicker =
      isSmall !== true &&
      project?.segments &&
      project?.segments.length > 1 &&
      this.props?.chart?.metadata?.type === "ModelDriver";

    return (
      <div className={styles.heatmap} style={style && isSmall ? style : {}} id={chartId}>
        {isSmall !== true && (
          <div
            className={styles.boldItem + " " + styles.bTitle + " " + styles.reportChartTitle}
            style={{
              textAlign: "center",
              marginTop: "0px",
              cursor: true === true ? "pointer" : "default"
            }}
            onClick={true === true ? () => replayActions(node) : () => {}}
          >
            {true ? (
              <OverlayTrigger
                placement="top"
                trigger={["hover"]}
                rootClose
                overlay={
                  <Popover id="popover-positioned-top">
                    <div className={styles.pAction}>{"Click to see how this was added."}</div>
                  </Popover>
                }
              >
                {this.renderIcon()}
              </OverlayTrigger>
            ) : (
              <OverlayTrigger
                placement="top"
                trigger={["hover"]}
                rootClose
                overlay={
                  <Popover id="popover-positioned-top">
                    <div className={styles.pAction}>{"Aible recommended chart"}</div>
                  </Popover>
                }
              >
                {this.renderIcon()}
              </OverlayTrigger>
            )}
            {chart?.title}
          </div>
        )}
        {isSmall !== true && (
          <div className={styles.hActions}>
            {renderPicker ? (
              <div className={styles.subHold}>
                <div className={styles.subgroupSelect}>
                  <div className={styles.smallSub}>{"Showing Subgroup:"}</div>
                  <Select
                    options={project.segments.map((segment) => ({
                      label: segment?.conditions?.[0]?.value || "Overall",
                      value: segment?.job?.job_id
                    }))}
                    value={
                      currentSegment !== undefined
                        ? {
                            label: currentSegment?.conditions?.[0]?.value || "Overall",
                            value: currentSegment?.job?.job_id
                          }
                        : undefined
                    }
                    onChange={(val) => {
                      updateDrilldownValue(project?.id, val.value, val.label);
                    }}
                  />
                </div>
              </div>
            ) : (
              <div />
            )}
            <div className={styles.hScale}>
              <Button
                onClick={() => updateIsHeatmapGlobalScale(!isHeatmapGlobalScale)}
                active={isHeatmapGlobalScale === true}
              >
                {"Global Scale"}
              </Button>
            </div>
          </div>
        )}
        <div
          className={isListChart ? styles.heatmapGridListChart : isSmall ? styles.heatmapGridSmall : styles.heatmapGrid}
          style={renderPicker ? { height: "calc(100vh - 320px)" } : style && isSmall !== true ? style : {}}
        >
          {values.map((value, i) => (
            <div key={i + "_" + runId} className={styles.valueRow} style={{ minHeight: 100 / values.length + "%" }}>
              {isSmall !== true && (
                <div className={styles.valueName} title={value}>
                  {value}
                </div>
              )}
              {hideGrid !== true && (
                <div
                  className={styles.values}
                  style={{
                    width: isSmall ? "100%" : "calc(100% - 100px)"
                  }}
                >
                  {models.map((model, j) => {
                    const scaledScore =
                      rChartScaled[value][model] !== undefined ? rChartScaled[value][model].toFixed(4) : undefined;

                    const score = rChart[value][model] !== undefined ? rChart[value][model].toFixed(4) : undefined;

                    const retScore = isHeatmapGlobalScale !== true ? score / maxY : scaledScore;

                    // const baseColor =
                    // 	scaledScore === undefined
                    // 		? "rgba(84, 192, 108, 1)"
                    // 		: scaledScore > 0
                    // 		? "rgba(84, 192, 108, 1)"
                    // 		: "rgba(192, 62, 90, 1)";
                    const baseColor =
                      retScore === undefined
                        ? "rgba(125, 105, 215, 1)"
                        : retScore > 0
                          ? "rgba(125, 105, 215, 1)"
                          : "rgba(213, 107, 39, 1)";
                    const cell = (
                      <div
                        key={i + "_" + j}
                        className={isSmall ? styles.gridCellSmall : styles.gridCell}
                        style={{
                          minWidth: `${100 / models.length}%`,
                          background: baseColor.replace("1)", Math.abs(retScore) + ")")
                        }}
                      ></div>
                    );

                    return isSmall ? (
                      cell
                    ) : (
                      <OverlayTrigger
                        key={i + "_" + j + "_" + runId}
                        placement="top"
                        trigger={["hover"]}
                        rootClose
                        overlay={
                          <Popover id="popover-positioned-top" title={column + ": " + value}>
                            <div className={styles.popItem}>
                              <div className={styles.popFirst}>{column + ":"}</div>
                              <div className={styles.popSecond}>{value}</div>
                            </div>
                            <div className={styles.popItem}>
                              <div className={styles.popFirst}>{"Model Name: "}</div>
                              <div className={styles.popSecond}>{model}</div>
                            </div>
                            <div className={styles.popItem}>
                              <div className={styles.popFirst}>{"Score: "}</div>
                              <div className={styles.popSecond}>{score}</div>
                            </div>
                          </Popover>
                        }
                      >
                        {cell}
                      </OverlayTrigger>
                    );
                  })}
                </div>
              )}
            </div>
          ))}
        </div>
        {isSmall !== true && false && (
          <div className={styles.narrativeHolder}>{"Possible heat map narrative down here"}</div>
        )}
      </div>
    );
  }
}
